import user from "../user/state";
import Vue from "vue";

export async function fetchProducts({ commit }) {
  try {
    const { data } = await Vue.axios({
      url: "/frontend/products"
    });
    commit("products/setProducts", data, {
      root: true
    });
  } catch (e) {
    commit("products/productsError", e.message, {
      root: true
    });
  } finally {
    // console.log("La petición para obetener productos ha finalizado");
  }
}

export async function fetchProduct({ commit }, params) {  
  try {
    const { data } = await Vue.axios({
      url: `/frontend/products/product?id=${params.id}&myProduct=${params.myProduct}`
    });
    commit("products/setProduct", data, {
      root: true
    });
  } catch {
    commit("productsError", e.message, {
      root: true
    });
  } finally {
    // console.log("La petición para obetener el producto ha finalizado");
  }
}

export async function fetchUserProducts({ commit }) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/products/user_products`
    });
    commit("products/setUserProducts", data, {
      root: true
    });
  } catch {
    commit("productsError", e.message, {
      root: true
    });
  } finally {
    // console.log("La petición para obetener el producto ha finalizado");
  }
}

export async function addProduct({ commit }, product) {
  try {
    await Vue.axios({
      method: "POST",
      url: "/frontend/products",
      data: {
        name: product.name,
        email: product.email,
        product_type: product.product_type,
        price: product.price,
        phone: product.phone,
        description: product.description,
        location: product.location,
        approved: false,
        user_id: user.current_user.id,
        expiration: 30
      }
    });
  } catch (e) {
    commit("productsError", e.message);
  } finally {
    // console.log("La petición para crear el producto ha finalizado");
  }
}

export async function updateProduct({ commit }, product) {
  try {
    await Vue.axios({
      method: "PUT",
      url: `/frontend/products/${product.id}`,
      data: {
        id: product.id,
        child_name: product.child_name,
        child_lastname: product.child_lastname,
        gender: product.gender,
        productday: product.productday,
        full_name_mother: product.full_name_mother,
        full_name_father: product.full_name_father
      }
    });
  } catch (e) {
    commit("productsError", e.message);
  } finally {
    // console.log("La petición para actualizar el producto ha finalizado");
  }
}

export async function updateProductExpiration({ commit }, product) {
  try {
    await Vue.axios({
      method: "POST",
      url: `/frontend/products/update_expiration`,
      data: {
        id: product.id
      }
    });
  } catch (e) {
    commit("productsError", e.message);
  } finally {
    // console.log("La petición para actualizar el anuncio ha finalizado");
  }
}

export async function removeProduct({ commit, dispatch }, id) {
  try {
    await Vue.axios({
      method: "DELETE",
      headers: {Authorization: localStorage.getItem("auth_token")},
      url: `/frontend/products/${id}`
    });
    dispatch("fetchProducts");
  } catch (e) {
    commit("productsError", e.message);
  } finally {
    // console.log("La petición para eliminar el producto ha finalizado");
  }
}
